import type { ShellUserAccountSettings } from '../core/models'
import { getShellApiInstance } from './shell-api-helpers'
import { getAccountFromContext } from './shell-api-helpers/context'
/**
 * getCurrentAccountRoles will return roles from the selected account
 */
export const getCurrentAccountRoles = (): readonly string[] => {
  const user = getShellApiInstance().user
  const accountKey = getAccountFromContext()?.key ?? null

  if (accountKey) {
    return user
      .getAccountByKey(accountKey)
      ?.licenses.map(license => license.roles)
      .flat() as string[]
  }

  return []
}

export const getCurrentAccountSettings = (): ShellUserAccountSettings | undefined => {
  const user = getShellApiInstance().user
  const accountKey = getAccountFromContext()?.key ?? null

  let account
  if (accountKey) {
    account = user.getAccountByKey(accountKey)
  }

  return account?.settings
}

/**
 * Checks if the user instance has any trial data
 */
export const isTrialUser = (): boolean => {
  const user = getShellApiInstance()?.user

  if (user?.key) {
    return (user.productTrial?.trial && user.productTrial?.active) ?? false
  }
  return false
}

/**
 * Checks if the user instance has any free account data
 */
export const isFreeUser = (): boolean => {
  const user = getShellApiInstance()?.user

  if (user?.key) {
    return (user.productTrial?.free && user.productTrial?.active) ?? false
  }
  return false
}

/**
 * Gets the end date of the user's active trial
 */
export const getProductTrialEndDate = () => {
  const user = getShellApiInstance()?.user

  if (user?.productTrial?.endDate) {
    return new Date(user.productTrial?.endDate)
  }
  return
}
